export type ShippingMethod =
  | 'free_shipping'
  | 'passport_ddp_canada'
  | 'expedited'
  | 'passport_ddp_all';

/**
 *
 * @param {String} countryCode The country code
 * @returns Shipping method code
 */
export const shippingMethodCodeForCountry = (
  countryCode: string,
): ShippingMethod => {
  switch (countryCode) {
    case 'US':
      return 'free_shipping';
    case 'US-E':
      return 'expedited';
    case 'CA':
      return 'passport_ddp_canada';
    default:
      return 'passport_ddp_all';
  }
};

/**
 *
 * @param {string} countryCode Country code to be checked against
 * @returns True if the country supports reactivation
 */
export const isCountryAbleToBeReactivated = (countryCode): boolean => {
  const countries = ['nz'];
  return countries.indexOf(countryCode.toLowerCase()) === -1;
};

/**
 *
 * @param {Subscription} subscription Subscription to check against
 * @returns {boolean} If the provided subscription is an international shipping address
 */
export const isSubscriptionInternational = (subscription: any): boolean =>
  subscription.shipping_address.country !== 'US';
